import styled from 'styled-components';

export const SuccessPageContainer = styled.div``
export const SuccessPageButton = styled.button`
    border-radius: 0px;
    height: 40px;
    width: 40%;
`